import { Box, Stack } from "@mui/system";
import BudgetControlGraphItemCard from "./BudgetControlGraphItemCard";

// ─── Mock helper functions (replace with your actual imports) ─────────────────
const formatCurrency = (value: number): string => {
  if (value == null || isNaN(value)) return "$0";
  return "$" + Math.round(value).toLocaleString("en-US");
};

const formatPercent = (value: number): string => {
  if (value == null || isNaN(value)) return "0%";
  return Math.round(value * 100) + "%";
};
// ─────────────────────────────────────────────────────────────────────────────

// ─── Static demo data (replaces sortedData from API) ─────────────────────────
const staticData = [
  {
    budget_dollar: 60509,
    budget_percentage: 1.05,
    qftd: 401,
    qftd_status: "success",
    qftd_percentage: 1.96,
    rr_budget_status: "success",
    rr_budget_percentage: 1.14,
    remaining_qftd: 52,
    cpa_income_dollar: 76711,
    total_income_dollar: 103220,
    cpa_budget_dollar: 103220,
    ftd: 423,
  },
];
// ─────────────────────────────────────────────────────────────────────────────

const BudgetControlGraphItem = ({
  sortedData = staticData,
}: {
  sortedData?: any[];
}) => {
  return (
    <>
      <Box>
        <Stack spacing={2}>
          {sortedData?.map((item: any, index: number) => (
            <BudgetControlGraphItemCard
              key={index}
              qftd={item.qftd}
              qftd_status={item.qftd_status}
              qftd_percentage={formatPercent(item.qftd_percentage)}
              budget_dollar={formatCurrency(item.budget_dollar)}
              budget_percentage={formatPercent(item.budget_percentage)}
              rr_budget_status={item.rr_budget_status}
              rr_budget_percentage={formatPercent(item.rr_budget_percentage)}
              remaining_qftd={item.remaining_qftd}
              cpa_income_dollar={formatCurrency(item.cpa_income_dollar)}
              total_income_dollar={formatCurrency(item.total_income_dollar)}
              cpa_budget_dollar={formatCurrency(item.cpa_budget_dollar)}
              ftd={item.ftd}
            />
          ))}
        </Stack>
      </Box>
    </>
  );
};

export default BudgetControlGraphItem;
